import React from 'react';
import {toJS} from 'mobx';
import {observer} from 'mobx-react';
import {Collapse, Table} from 'antd';
import orderDetailStore from '@store/User/UserList/OrderDetailStore';

const Panel = Collapse.Panel;

@observer
class OrderDetailTicketTableModal extends React.Component {

    columns = [
        {
            title: '选号方式',
            dataIndex: 'play_type_name'
        },
        {
            title: '投注选项',
            render(text, record, index) {

                // let redStyle = {
                //   color: 'red'
                // };

                return (
                    <span>{record.betData.getOptionString()}</span>
                )
            }
        },
        {
            title: '注数',
            dataIndex: 'count'
        },
        {
            title: '倍数',
            dataIndex: 'multiple'
        },
        {
            title: '投注金额',
            dataIndex: 'money'
        },
        {
            title: '状态',
            render(text, record, index) {

                let redStyle = {
                    color: 'red'
                };

                if (record.is_win) {
                    return (
                        <span style={redStyle}>{record.status_name}</span>
                    )
                }

                return (
                    <span>{record.status_name}</span>
                )
            }
        },
        {
            title: '出票结果',
            dataIndex: 'info'
        }
    ];

    constructor() {
        super();
        this.state = {someKey: 'someValue'};
    }


    render() {

        const customPanelStyle = {
            background: '#f7f7f7',
            borderRadius: 4,
            border: 0,
            overflow: 'hidden',
        };

        return (
            <Collapse bordered={false}>
                <Panel header="出票明细" key="1" style={customPanelStyle}>
                    <Table
                        size='small'
                        dataSource={toJS(orderDetailStore.orderDetailData.ticket_data)}
                        columns={this.columns}
                        rowKey={(record) => {
                            return record.id;
                        }
                        }
                        pagination={false}
                        bordered/>
                </Panel>
            </Collapse>

        );
    }

    componentDidMount() {
        this.setState({someKey: 'otherValue'});
    }
}

export default OrderDetailTicketTableModal;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/User/UserList/Order/OrderDetailTicketTableModal.jsx